// Balances helpers: statement-cycle dates (1st-15th / 16th-end) and number formatting. Moved out of Balances.jsx 2026-10-14.

// ─── Period helpers (bi-weekly cycles: 1-15, 16-end of month) ─────────
export function pad2(n) { return String(n).padStart(2, '0'); }
export function cycleKeyFromDate(fromIso) {
  const m = String(fromIso || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  const day = parseInt(m[3]);
  return m[1] + '-' + m[2] + '-' + (day <= 15 ? 'A' : 'B');
}
export function fmtCycleLabel(cycleKey) {
  const m = String(cycleKey || '').match(/^(\d{4})-(\d{2})-(A|B)$/);
  if (!m) return cycleKey || '';
  const monthName = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][parseInt(m[2]) - 1];
  return monthName + ' ' + m[1] + ' · ' + (m[3] === 'A' ? '1-15' : '16-EOM');
}
export function currentCycle(today) {
  const d = today || new Date();
  const y = d.getFullYear(), m = d.getMonth();
  const day = d.getDate();
  if (day <= 15) {
    return { from: iso(y, m, 1), to: iso(y, m, 15) };
  }
  const lastDay = new Date(y, m + 1, 0).getDate();
  return { from: iso(y, m, 16), to: iso(y, m, lastDay) };
}
export function iso(y, m, d) {
  return y + '-' + String(m + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
}
// fmtMoney moved to utils/money.js (2026-07-03 code-review consolidation).
// Aliased on import so the ~50 call sites don't need to change.
export function fmtNum(n) { return n == null ? '—' : Number(n).toLocaleString(); }
